export default (r: number, g: number, b: number) => `rgb(${r},${g},${b})`;
